module.exports = __webpack_public_path__ + "media/images/promo/black_friday_2019/truck-c9ddb441587349dd56468e811783a585.png";